"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartProcessor = void 0;
const chartDefinitions_1 = require("./chartDefinitions");
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const sum_1 = __importDefault(require("lodash/sum"));
const chartTools_1 = require("./chartTools");
const chartScoring_1 = require("./chartScoring");
class ChartProcessor {
    constructor(givenDefinitions = []) {
        this.givenDefinitions = givenDefinitions;
        this.chartsProcessing = [];
        this.charts = [];
        this.availableColumnsDict = {};
        this.availableColumns = [];
        this.autoDetectCharts = false;
        this.rowsAdded = 0;
        for (const definition of givenDefinitions) {
            this.chartsProcessing.push({
                definition,
                rowsAdded: 0,
                bucketKeysOrdered: [],
                buckets: {},
                bucketKeyDateParsed: {},
                isGivenDefinition: true,
                invalidXRows: 0,
                invalidYRows: {},
                availableColumns: [],
                validYRows: {},
                topDistinctValues: {},
            });
        }
        this.autoDetectCharts = this.givenDefinitions.length == 0;
    }
    // findOrCreateChart(definition: ChartDefinition, isGivenDefinition: boolean): ProcessedChart {
    //   const signatureItems = [
    //     definition.chartType,
    //     definition.xdef.field,
    //     definition.xdef.transformFunction,
    //     definition.ydefs.map(y => y.field).join(','),
    //   ];
    //   const signature = signatureItems.join('::');
    //   if (this.chartsBySignature[signature]) {
    //     return this.chartsBySignature[signature];
    //   }
    //   const chart: ProcessedChart = {
    //     definition,
    //     rowsAdded: 0,
    //     bucketKeysOrdered: [],
    //     buckets: {},
    //     bucketKeyDateParsed: {},
    //     isGivenDefinition,
    //   };
    //   this.chartsBySignature[signature] = chart;
    //   return chart;
    // }
    addRow(row) {
        const dateColumns = {};
        const numericColumns = {};
        const numericColumnsForAutodetect = {};
        const stringColumns = {};
        for (const [key, value] of Object.entries(row)) {
            const number = typeof value == 'string' ? Number(value) : typeof value == 'number' ? value : NaN;
            this.availableColumnsDict[key] = {
                field: key,
            };
            const keyLower = key.toLowerCase();
            const keyIsId = keyLower.endsWith('_id') || keyLower == 'id' || key.endsWith('Id');
            const parsedDate = (0, chartTools_1.tryParseChartDate)(value);
            if (parsedDate) {
                dateColumns[key] = parsedDate;
                continue;
            }
            if (!isNaN(number) && isFinite(number)) {
                numericColumns[key] = number;
                if (!keyIsId) {
                    numericColumnsForAutodetect[key] = number; // for auto-detecting charts
                }
                continue;
            }
            if (typeof value === 'string' && isNaN(number) && value.length < 100) {
                stringColumns[key] = value;
            }
        }
        // const sortedNumericColumnns = Object.keys(numericColumns).sort();
        if (this.autoDetectCharts) {
            // create charts from data, if there are no given definitions
            for (const datecol in dateColumns) {
                let usedChart = this.chartsProcessing.find(chart => {
                    var _a;
                    return !chart.isGivenDefinition &&
                        chart.definition.xdef.field === datecol &&
                        ((_a = chart.definition.xdef.transformFunction) === null || _a === void 0 ? void 0 : _a.startsWith('date:'));
                });
                if (!usedChart &&
                    (this.rowsAdded < chartDefinitions_1.ChartLimits.APPLY_LIMIT_AFTER_ROWS ||
                        this.chartsProcessing.length < chartDefinitions_1.ChartLimits.AUTODETECT_CHART_LIMIT)) {
                    usedChart = {
                        definition: {
                            chartType: 'line',
                            xdef: {
                                field: datecol,
                                transformFunction: 'date:day',
                            },
                            ydefs: [],
                        },
                        rowsAdded: 0,
                        bucketKeysOrdered: [],
                        buckets: {},
                        bucketKeyDateParsed: {},
                        isGivenDefinition: false,
                        invalidXRows: 0,
                        invalidYRows: {},
                        availableColumns: [],
                        validYRows: {},
                        topDistinctValues: {},
                    };
                    this.chartsProcessing.push(usedChart);
                }
                for (const [key, value] of Object.entries(row)) {
                    if (value == null)
                        continue;
                    if (key == datecol)
                        continue; // skip date column itself
                    let existingYDef = usedChart.definition.ydefs.find(y => y.field === key);
                    if (!existingYDef &&
                        (this.rowsAdded < chartDefinitions_1.ChartLimits.APPLY_LIMIT_AFTER_ROWS ||
                            usedChart.definition.ydefs.length < chartDefinitions_1.ChartLimits.AUTODETECT_MEASURES_LIMIT)) {
                        existingYDef = {
                            field: key,
                            aggregateFunction: 'sum',
                        };
                        usedChart.definition.ydefs.push(existingYDef);
                    }
                }
            }
        }
        // apply on all charts with this date column
        for (const chart of this.chartsProcessing) {
            if (chart.errorMessage) {
                continue; // skip charts with errors
            }
            this.applyRawData(chart, row, dateColumns[chart.definition.xdef.field], chart.isGivenDefinition ? numericColumns : numericColumnsForAutodetect, stringColumns);
            if (Object.keys(chart.buckets).length > chartDefinitions_1.ChartLimits.CHART_FILL_LIMIT) {
                chart.errorMessage = `Chart has too many buckets, limit is ${chartDefinitions_1.ChartLimits.CHART_FILL_LIMIT}.`;
            }
        }
        for (let i = 0; i < this.chartsProcessing.length; i++) {
            if (this.chartsProcessing[i].errorMessage) {
                continue; // skip charts with errors
            }
            this.chartsProcessing[i] = (0, chartTools_1.autoAggregateCompactTimelineChart)(this.chartsProcessing[i]);
        }
        this.rowsAdded += 1;
        if (this.rowsAdded == chartDefinitions_1.ChartLimits.APPLY_LIMIT_AFTER_ROWS) {
            this.applyLimitsOnCharts();
        }
    }
    applyLimitsOnCharts() {
        const autodetectProcessingCharts = this.chartsProcessing.filter(chart => !chart.isGivenDefinition);
        if (autodetectProcessingCharts.length > chartDefinitions_1.ChartLimits.AUTODETECT_CHART_LIMIT) {
            const newAutodetectProcessingCharts = (0, sortBy_1.default)(this.chartsProcessing.slice(0, chartDefinitions_1.ChartLimits.AUTODETECT_CHART_LIMIT), chart => -(0, chartScoring_1.getChartScore)(chart));
            for (const chart of autodetectProcessingCharts) {
                chart.definition.ydefs = (0, sortBy_1.default)(chart.definition.ydefs, yfield => -(0, chartScoring_1.getChartYFieldScore)(chart, yfield)).slice(0, chartDefinitions_1.ChartLimits.AUTODETECT_MEASURES_LIMIT);
            }
            this.chartsProcessing = [
                ...this.chartsProcessing.filter(chart => chart.isGivenDefinition),
                ...newAutodetectProcessingCharts,
            ];
        }
    }
    addRows(...rows) {
        for (const row of rows) {
            this.addRow(row);
        }
    }
    finalize() {
        var _a;
        this.applyLimitsOnCharts();
        this.availableColumns = Object.values(this.availableColumnsDict);
        for (const chart of this.chartsProcessing) {
            if (chart.errorMessage) {
                this.charts.push(chart);
                continue;
            }
            let addedChart = chart;
            if (chart.rowsAdded == 0 && !chart.isGivenDefinition) {
                continue; // skip empty charts
            }
            const sortOrder = (_a = chart.definition.xdef.sortOrder) !== null && _a !== void 0 ? _a : 'ascKeys';
            if (sortOrder != 'natural') {
                if (sortOrder == 'ascKeys' || sortOrder == 'descKeys') {
                    if (chart.definition.chartType == 'line' && chart.definition.xdef.transformFunction.startsWith('date:')) {
                        addedChart = (0, chartTools_1.autoAggregateCompactTimelineChart)(addedChart);
                        (0, chartTools_1.fillChartTimelineBuckets)(addedChart);
                    }
                    if (addedChart.errorMessage) {
                        this.charts.push(addedChart);
                        continue;
                    }
                    addedChart.bucketKeysOrdered = (0, sortBy_1.default)(Object.keys(addedChart.buckets));
                    if (sortOrder == 'descKeys') {
                        addedChart.bucketKeysOrdered.reverse();
                    }
                }
                if (sortOrder == 'ascValues' || sortOrder == 'descValues') {
                    addedChart.bucketKeysOrdered = (0, sortBy_1.default)(Object.keys(addedChart.buckets), key => (0, chartTools_1.computeChartBucketCardinality)(addedChart.buckets[key]));
                    if (sortOrder == 'descValues') {
                        addedChart.bucketKeysOrdered.reverse();
                    }
                }
            }
            if (!addedChart.isGivenDefinition) {
                addedChart = Object.assign(Object.assign({}, addedChart), { definition: Object.assign(Object.assign({}, addedChart.definition), { ydefs: addedChart.definition.ydefs.filter(y => !addedChart.invalidYRows[y.field] &&
                            addedChart.validYRows[y.field] / addedChart.rowsAdded >= chartDefinitions_1.ChartLimits.VALID_VALUE_RATIO_LIMIT) }) });
            }
            if (addedChart.definition.trimXCountLimit != null &&
                addedChart.bucketKeysOrdered.length > addedChart.definition.trimXCountLimit) {
                addedChart.bucketKeysOrdered = addedChart.bucketKeysOrdered.slice(0, addedChart.definition.trimXCountLimit);
            }
            if (addedChart) {
                addedChart.availableColumns = this.availableColumns;
                this.charts.push(addedChart);
            }
            this.groupPieOtherBuckets(addedChart);
        }
        this.charts = [
            ...this.charts.filter(x => x.isGivenDefinition),
            ...(0, sortBy_1.default)(this.charts.filter(x => !x.isGivenDefinition), chart => -(0, chartScoring_1.getChartScore)(chart)),
        ];
    }
    groupPieOtherBuckets(chart) {
        var _a, _b, _c;
        if (chart.definition.chartType !== 'pie') {
            return; // only for pie charts
        }
        const ratioLimit = (_a = chart.definition.pieRatioLimit) !== null && _a !== void 0 ? _a : chartDefinitions_1.ChartLimits.PIE_RATIO_LIMIT;
        const countLimit = (_b = chart.definition.pieCountLimit) !== null && _b !== void 0 ? _b : chartDefinitions_1.ChartLimits.PIE_COUNT_LIMIT;
        if (ratioLimit == 0 && countLimit == 0) {
            return; // no grouping if limit is 0
        }
        const otherBucket = {};
        let newBuckets = {};
        const cardSum = (0, sum_1.default)(Object.values(chart.buckets).map(bucket => (0, chartTools_1.computeChartBucketCardinality)(bucket)));
        if (cardSum == 0) {
            return; // no buckets to process
        }
        for (const [bucketKey, bucket] of Object.entries(chart.buckets)) {
            if ((0, chartTools_1.computeChartBucketCardinality)(bucket) / cardSum < ratioLimit) {
                for (const field in bucket) {
                    otherBucket[field] = ((_c = otherBucket[field]) !== null && _c !== void 0 ? _c : 0) + bucket[field];
                }
            }
            else {
                newBuckets[bucketKey] = bucket;
            }
        }
        if (Object.keys(newBuckets).length > countLimit) {
            const sortedBucketKeys = (0, sortBy_1.default)(Object.entries(newBuckets), ([, bucket]) => -(0, chartTools_1.computeChartBucketCardinality)(bucket)).map(([key]) => key);
            const newBuckets2 = {};
            sortedBucketKeys.forEach((key, index) => {
                var _a;
                if (index < countLimit) {
                    newBuckets2[key] = newBuckets[key];
                }
                else {
                    for (const field in newBuckets[key]) {
                        otherBucket[field] = ((_a = otherBucket[field]) !== null && _a !== void 0 ? _a : 0) + newBuckets[key][field];
                    }
                }
            });
            newBuckets = newBuckets2;
        }
        if (Object.keys(otherBucket).length > 0) {
            newBuckets['Other'] = otherBucket;
        }
        chart.buckets = newBuckets;
        chart.bucketKeysOrdered = [...chart.bucketKeysOrdered, 'Other'].filter(key => key in newBuckets);
    }
    applyRawData(chart, row, dateParsed, numericColumns, stringColumns) {
        if (chart.definition.xdef == null) {
            return;
        }
        if (row[chart.definition.xdef.field] == null) {
            return;
        }
        if (dateParsed == null && chart.definition.xdef.transformFunction.startsWith('date:')) {
            chart.invalidXRows += 1;
            return; // skip if date is invalid
        }
        const [bucketKey, bucketKeyParsed] = (0, chartTools_1.computeChartBucketKey)(dateParsed, chart, row);
        if (!bucketKey) {
            return; // skip if no bucket key
        }
        if (bucketKeyParsed) {
            chart.bucketKeyDateParsed[bucketKey] = bucketKeyParsed;
        }
        if (chart.minX == null || bucketKey < chart.minX) {
            chart.minX = bucketKey;
        }
        if (chart.maxX == null || bucketKey > chart.maxX) {
            chart.maxX = bucketKey;
        }
        if (!chart.buckets[bucketKey]) {
            chart.buckets[bucketKey] = {};
            if (chart.definition.xdef.sortOrder == 'natural') {
                chart.bucketKeysOrdered.push(bucketKey);
            }
        }
        (0, chartTools_1.aggregateChartNumericValuesFromSource)(chart, bucketKey, numericColumns, row);
        chart.rowsAdded += 1;
    }
}
exports.ChartProcessor = ChartProcessor;
